// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bd954327","239":"e39fb35b","453":"03346f77","455":"2186bbf4"}[chunkId] + ".chunk.js";
};